import { IGetNewbuildingLayoutWithOffersDesktopResponseSchema } from 'shared/repositories/search-offers/entities/entities/GetNewbuildingLayoutWithOffersDesktopResponseSchema';

import { INewbuildingLayoutWithOffers } from '../../types/residentialComplexLayouts/layoutWithOffers/layoutWithOffers';

export const prepareNewbuildingLayoutWithOffers = (
  response: IGetNewbuildingLayoutWithOffersDesktopResponseSchema,
): INewbuildingLayoutWithOffers | null => {
  if (!response || !response.layout) {
    return null;
  }

  return response.layout;
};
